export const institutionalEn = {
  'institutional.title': 'Institutional Consulting',
  'institutional.subtitle': 'We structure and manage your state projects end-to-end',
  'institutional.forWhom.title': 'For Whom',
  'institutional.forWhom.description': 'Ministries, national agencies, international donors (AFD, World Bank, AfDB)',
  'institutional.whatWeDo.title': 'What We Do',
  'institutional.whatWeDo.item1': 'Digitalization of national registries',
  'institutional.whatWeDo.item2': 'Governance and sovereign information systems',
  'institutional.whatWeDo.item3': 'Management of structural EPC+F / BOT projects',
  'institutional.whatWeDo.item4': 'Sovereign cloud and data protection',
  'institutional.howWeWork.title': 'How We Work',
  'institutional.howWeWork.description': 'We operate in three phases: strategic diagnosis, technical design, deployment and skills transfer.',
  'institutional.howWeWork.phase1': 'Strategic Diagnosis',
  'institutional.howWeWork.phase2': 'Technical Design',
  'institutional.howWeWork.phase3': 'Deployment & Transfer',
  'institutional.cta': 'Discuss your institutional project'
};

export default institutionalEn;